// @flow
import { getIsAnyMissingHumidifierType, getKnownHumidifierType } from '~/core/state/products/thermostat/selectors';

import Component from './component';
import { connectWithLifecycle } from 'react-lifecycle-component';
import { deviceHumidityModes } from '~/core/constants/devices';
import { hideHumidityControl } from '~/core/state/application/actions';
import { setHumidifierType } from '~/core/state/products/thermostat/actions';

// This will be replaced by BK at some point
// but for now we've agreed to do it in-app.
function setAllStatsToExistingHumidifyType(nextProps = {}) {
    if (
        this.props.isMissingAHumidifierType &&
        this.props.knownHumidityType &&
        this.props.knownHumidityType !== nextProps.knownHumidityType
    ) {
        this.props.setAs(this.props.knownHumidityType);
    }
}

const mapStateToProps = state => {
    const knownHumidityType = getKnownHumidifierType(state);
    const isMissingAHumidifierType = getIsAnyMissingHumidifierType(state);
    return {
        knownHumidityType,
        isMissingAHumidifierType,
        isOpen: isMissingAHumidifierType && !knownHumidityType,
        setAllStatsToExistingHumidifyType,
        componentWillReceiveProps: setAllStatsToExistingHumidifyType
    };
};

const mapDispatchToProps = {
    setAs: setHumidifierType,
    setAsHumidifier: () => setHumidifierType(deviceHumidityModes.HUMIDIFIER),
    setAsDeHumidifier: () => setHumidifierType(deviceHumidityModes.DEHUMIDIFIER),
    hideHumidityControl
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { isOpen, setAllStatsToExistingHumidifyType } = stateProps;
    const { hideHumidityControl } = dispatchProps;
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        componentDidMount: function(nextProps) {
            setAllStatsToExistingHumidifyType.call(this, nextProps);
            if (!isOpen) {
                hideHumidityControl();
            }
        }
    };
};

export default connectWithLifecycle(mapStateToProps, mapDispatchToProps, mergeProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/humidity-control-modal/index.js